import { toNumber } from '../../helpers'
import { formatStakeholdersListToBE } from '../../formatters/stakeholdersListTransformers'

import { TOTAL_ACTIVITY_HOURS, COUNTRY_ID, TOTAL_INVESTMENT, TITLE } from '../../fields'
import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'

export const transformValuesToBE = (sroiReport, values) => {
  return {
    [TITLE]: values[TITLE],
    payload: {
      ...sroiReport.payload,
      // general inputs section
      [COUNTRY_ID]: values[COUNTRY_ID],
      [TOTAL_INVESTMENT]: toNumber(values[TOTAL_INVESTMENT]),
      [TOTAL_ACTIVITY_HOURS]: toNumber(values[TOTAL_ACTIVITY_HOURS]),
      // stakeholders section
      [STAKEHOLDERS_LIST]: formatStakeholdersListToBE(values)
    }
  }
}
